import React, { useState, useEffect } from "react";
import FearGreed from "../components/FearGreed";
import Chart from "./Chart";

interface HomeProps {
  symbol?: string;
}

export default function Home({ symbol = "BTC/USDT" }: HomeProps) {
  const [chartHeight, setChartHeight] = useState(window.innerHeight * 0.5);

  useEffect(() => {
    const handleResize = () => setChartHeight(window.innerHeight * 0.5);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 p-4 md:p-6">
      <div className="flex flex-col gap-4 md:gap-6">
        {/* Chart - main display at top */}
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-4">
          <div className="xl:col-span-3">
            <Chart height={chartHeight} symbol={symbol as any} />
          </div>
        </div>
        
        {/* Fear & Greed Index - below chart */}
        <FearGreed height={100} />
      </div>
    </div>
  );
}
